import Home from '@/views/home/Home'
import ParentComponent from '@/components/parentComponent/ParentComponent'
export default [
  {
    path: '',
    name: 'home',
    meta: {
      title: '首页',
    },
    component: Home
  },
  {
    path: '/detail/:id',
    name: 'detail',
    meta: {
      title: '详情页',
    },
    component: () => import('@/views/detail/Detail')
  },
]
